import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col, Modal } from "react-bootstrap";
import "./ProjectsSlider.css";

const projectsData = [
  {
    id: 1,
    image: "/images/land-1.webp",
    video: "/images/projects/safety-acrylic-encased-suspended-pool/safety-acrylic-encased-suspended-pool.mp4",
    title: "تركيب شلال جداري واكريليك مسبح",
  },
  {
    id: 2,
    image: "/images/land-2.webp",
    video: "/images/projects/moving-pool-pvc/moving-pool-pvc.mp4",
    title: "حواجز أمان مسابح وأغطية أطفال",
  },
  {
    id: 3,
    image: "/images/land-3.webp",
    video: "/images/projects/transparent-pool-safety/transparent-pool-safety-1.mp4",
    title: "تنسيق نوافير مائية عصرية",
  },
  {
    id: 4,
    image: "/images/land-8.webp",
    video: "/images/projects/safety-wooden-encased-suspended-pool/safety-wooden-encased-suspended-pool.mp4",
    title: "أعمال أمان وسلامة المسابح",
  },
  {
    id: 5,
    image: "/images/projects/tube-fountain/tube-fountain-1.webp",
    video: "/images/projects/tube-fountain/tube-fountain.mp4",
    title: "أعمال أمان وسلامة المسابح",
  },
  {
    id: 6,
    image: "/images/land-4.webp",
    video: "/images/projects/variable-depth-pool-safety/variable-depth-pool-safety.mp4",
    title: "تركيب شبك وحواجز حماية للمسابح",
  },
  {
    id: 7,
    image: "/images/land-5.webp",
    video: "/images/projects/variable-depth-pool-safety/variable-depth-pool-safety.mp4",
    title: "شلالات استيل واستراحة مسبح",
  },
  {
    id: 8,
    image: "/images/land-6.webp",
    video: "/images/projects/fixed-pool/fixed-pool-pvc.mp4",
    title: "غطاء مسبح متحرك أوتوماتيكي",
  },
  {
    id: 9,
    image: "/images/land-7.webp",
    video: "/images/projects/safety-wooden-encased-suspended-pool/safety-wooden-encased-suspended-pool-1.mp4",
    title: "تجهيز وإكسسوارات مسابح حديثة",
  }
];

const ProjectsSlider = () => {
  const sectionRef = useRef(null);
  const [animate, setAnimate] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [activeVideo, setActiveVideo] = useState({ src: "", title: "" });

  const doubledProjects = [...projectsData, ...projectsData];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setAnimate(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.15 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const handleOpenVideo = (videoSrc, title) => {
    setActiveVideo({ src: videoSrc, title });
    setShowModal(true);
  };

  const handleCloseVideo = () => {
    setShowModal(false);
    setActiveVideo({ src: "", title: "" });
  };

  return (
    <section
      className={`continuous-slider ${animate ? "animate" : ""}`}
      id="projects"
      ref={sectionRef}
    >
      <Container>
        <Row className="justify-content-center text-center mb-5">
          <Col lg={8}>
            <div className="fade-down delay-1">
              <h2 className="section-title">أعمالنا</h2>
              <div className="title-underline"></div>
              <p className="section-subtitle">
                مجموعة مختارة من مشاريع تركيب أمان المسابح، الشلالات والنوافير المنفذة باحترافية
              </p>
            </div>
          </Col>
        </Row>
      </Container>

      <div className="slider-wrapper fade-up delay-2">
        <div className="slider-track">
          {doubledProjects.map((project, idx) => (
            <div
              className="slide"
              key={idx}
              onClick={() => handleOpenVideo(project.video, project.title)}
            >
              <div className="slide-card">
                <img src={project.image} alt={project.title} loading="lazy" />

                <div className="video-overlay">
                  <div className="play-button-wrapper">
                    <div className="play-pulse"></div>
                    <div className="play-icon">
                      <i className="fa-solid fa-play"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* 🌟 Video Modal بعد تصحيح الـ video tag 🌟 */}
      <Modal
        show={showModal}
        onHide={handleCloseVideo}
        centered
        size="lg"
        className="project-video-modal"
      >
        <Modal.Body className="p-0">
          {activeVideo.src && (
            <div className="ratio ratio-16x9">
              <video
                key={activeVideo.src}
                controls
                autoPlay
                playsInline
                preload="metadata"
                controlsList="nodownload"
                className="video-player"
              >
                <source src={activeVideo.src} type="video/mp4" />
                متصفحك لا يدعم تشغيل الفيديو.
              </video>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </section>
  );
};

export default ProjectsSlider;